import React from 'react';
import { Redirect } from 'react-router-dom';
import { PageTitle } from '../../PageTitle';

import { NeedsAttentionComponent } from './needs_attention_component';

import { DashboardService } from '../../../services';

import i18next from "i18next";

class LegacyNeedsAttentionDashboardView extends React.Component {
  constructor(props) {
    super(props);

    var successMessage = null;

    if (localStorage.getItem('global_success_message')) {
      successMessage = localStorage.getItem('global_success_message');
    }

    this.state = {
      hasError: false,
      needingAttentionData: null,
      allOtherData: null,
      gotoLocationGroupingId: null,
      localSuccessMessage: successMessage
    };
  }

  componentDidMount() {
    this.refresh();
  }

  refresh() {
    this.setState({loading: true});

    DashboardService.getNeedsAttentionDashboardData().then(response => {
      const needingAttentionData = response.data.filter(entry => 
        (entry.sensorsTotal > 0 || entry.routerTotal > 0 || entry.gatewaysTotal > 0) && entry.criticalAlertCount != 0
      ).sort((a, b) => a.locationName.localeCompare(b.locationName));

      const allOtherData = response.data.filter(entry => 
        (entry.sensorsTotal > 0 || entry.routerTotal > 0 || entry.gatewaysTotal > 0)
      ).sort((a, b) => a.locationName.localeCompare(b.locationName));

      this.setState({
        needingAttentionData: needingAttentionData,
        allOtherData: allOtherData,
        loading: false
      });
    }).catch((err => {
      console.error(err);
       this.setState({loading: false});
    }));
  }

  renderMessages() {
    return this.state.localErrorMessage || this.state.localSuccessMessage
      ? (<Message  messages={{ state: { successMessage: this.state.localSuccessMessage } }} errorMessage={this.state.localErrorMessage} messageDismissCallback={this.messageDismissCallback.bind(this)} />)
      : (null)
  }

  messageDismissCallback() {
    localStorage.removeItem('global_success_message');
    this.setState({ localErrorMessage: null, localSuccessMessage: null });
  }

  locationClicked(deviceGroupingId) {
    this.setState({gotoLocationGroupingId: deviceGroupingId});
  }

  render() {  
    if (this.state.gotoLocationGroupingId) {
      return (
          <Redirect push exact to={{
            pathname: `/monitoring/locations/${this.state.gotoLocationGroupingId}/devices`
          }}/>
      );
    }

    if (this.state.loading) {
      return (<div className="loader">Loading...</div>);
    } else if (this.state.needingAttentionData) {
      return (
        <div className="animated fadeIn needs-attention-dash">
          <div className="row">
            {this.renderMessages()}
            <PageTitle
              title={ i18next.t('pages.dashboard.header') }
              refreshFunction={this.refresh.bind(this)}
            />
          </div>

          <NeedsAttentionComponent 
              needingAttentionData={this.state.needingAttentionData} 
              allOtherData={this.state.allOtherData}
              locationClicked={this.locationClicked.bind(this)} 
              isMobile={this.props.isMobile}
              isAdmin={false}
            />

        </div>
      );
    } else {
      return (
        <div className="animated fadeIn">
          <div className="row">
            {this.renderMessages()}
            <PageTitle
              title={ i18next.t('pages.dashboard.header') }
              refreshFunction={this.refresh.bind(this)}
            />
          </div>
          <div>Error...</div>
        </div>
      );
    }
  }
}

export default LegacyNeedsAttentionDashboardView;
